export const HUD_PROGRAM_NAME = 'HUD';
export const HOME_PROGRAM_NAME = 'HOME';
export const CITC_PROGRAM_NAME = 'CITC';
export const CDGB_PROGRAM_NAME = 'CDGB';
export const RD_PROGRAM_NAME = 'RD';
export const LIHTC_PROGRAM_NAME = 'LIHTC';
export const LIHTC_HOME_PROGRAM_NAME = 'LIHTC/HOME';
export const NOAH_PROGRAM_NAME = 'NOAH';
export const DEFERRED_LOAN_PROGRAM_NAME = 'Deferred Loan';
export const VHCB_PROGRAM_NAME = 'VHCB';
export const NSP_PROGRAM_NAME = 'NSP';
export const AHP_PROGRAM_NAME = 'AHP';
export const KCMO_PROGRAM_NAME = 'KCMO';
export const ST_LOUIS_FUNDS_PROGRAM_NAME = 'St. Louis Funds';
export const HTF_PROGRAM_NAME = 'HTF';
export const TCAP_PROGRAM_NAME = 'TCAP';
export const BOND_PROGRAM_NAME = 'BOND';
export const PH_PROGRAM_NAME = 'PH';
export const PBV_PROGRAM_NAME = 'PBV';

export const RECERT_CERT_TYPE = 'RECERT';
export const RECERT_UT_CERT_TYPE = 'RECERT_UT';
export const INITIAL_CERT_TYPE = 'INITIAL';
export const INITIAL_UT_CERT_TYPE = 'INITIAL_UT';
export const MOVE_IN_CERT_TYPE = 'MOVE_IN';
export const MOVE_OUT_CERT_TYPE = 'MOVE_OUT';
export const TERMINATION_CERT_TYPE = 'TERMINATION';
export const INTERIM_CERT_TYPE = 'INTERIM';
export const INTERIM_UT_CERT_TYPE = 'INTERIM_UT';
export const EVICTION_CERT_TYPE = 'EVICTION';
export const CO_TENANT_TO_TENANT_CERT_TYPE = 'CO_TENANT_TO_TENANT';
export const INITIATE_ABSENCE_CERT_TYPE = 'INITIATE_ABSENCE';
export const TERMINATE_ABSENCE_CERT_TYPE = 'TERMINATE_ABSENCE';

// ENG-30153: a converted combo transfer cert (RECERT_UT / INTERIM_UT / INITIAL_UT) reuses its base
// cert type's field definitions. The component-library `baseFields` maps are keyed by base cert type
// and have no _UT entries, so field lookups must map a _UT type to its base; all other types pass
// through unchanged.
const BASE_CERT_TYPE_FOR_FIELD_LOOKUP = {
  [RECERT_UT_CERT_TYPE]: RECERT_CERT_TYPE,
  [INTERIM_UT_CERT_TYPE]: INTERIM_CERT_TYPE,
  [INITIAL_UT_CERT_TYPE]: INITIAL_CERT_TYPE,
};
export const baseCertTypeForFieldLookup = (certificationType) =>
  BASE_CERT_TYPE_FOR_FIELD_LOOKUP[certificationType] ?? certificationType;
export const VACATE_CERT_TYPE = 'VACATE';
export const ASSIGN_REMOVE_RA_CERT_TYPE = 'ASSIGN_REMOVE_RA';
export const GROSS_RENT_CERT_TYPE = 'GROSS_RENT';
export const UNIT_TRANSFER_CERT_TYPE = 'UNIT_TRANSFER';
export const RD_GROSS_RENT_CERT_TYPE = 'RD_GROSS_RENT';
// To be implemented
export const FAMILY_SELF_SUFFICIENCY_CERT_TYPE = 'FAMILY_SELF_SUFFICIENCY';
export const FLAT_RENT_ANNUAL_UPDATE_CERT_TYPE = 'FLAT_RENT_ANNUAL_UPDATE';
export const FSS_ADDENDUM_CERT_TYPE = 'FSS_ADDENDUM';

export const GUARANTOR_LEASE_SIGNER = 'Guarantor Lease Signer';
export const MINOR = 'Minor';
export const CODES_FOR_811 = ['6', '8'];
export const HUD_202_PRAC_CODE = '7';

export const NON_CITIZEN_RULE_SUBSIDY_CODES = ['1', '2', '3', 'S'];
export const CITIZEN_ELIGIBILITY_NOT_SUBJECT_ID =
  '39d1a949-ac35-4293-b2f6-79371e96042b';
export const CITIZEN_ELIGIBILITY_ALL_ELIGIBLE_ID =
  '9db0cdfe-da4f-416e-86cc-8a6368552dbc';
export const CITIZEN_ELIGIBILITY_FULL_ASSISTANCE_ID =
  'f44aca62-6741-408b-940c-b691d49c8e47';

export const certificationTypeNameDefinitions = {
  CO_TENANT_TO_TENANT: 'Co-Tenant to Tenant (C)',
  CORRECTION: 'Correction for Recert',
  EVICTION: 'Eviction (E)',
  INITIAL: 'Initial Certification (IC)',
  INITIATE_ABSENCE: 'Initiate Absence (L)',
  INTERIM: 'Interim Recert (IR)',
  MODIFY: 'Modify (M)',
  MOVE_IN: 'Move-in (MI)',
  MOVE_IN_RD: 'Initial (I)',
  MOVE_OUT: 'Move-out (MO)',
  RECERT: 'Annual Recert (AR)',
  RECERT_RD: 'Recertification (R)',
  TERMINATION: 'Termination (TM)',
  TERMINATE_ABSENCE: 'Terminate Absence (B)',
  VACATE: 'Vacate (V)',
  ASSIGN_REMOVE_RA: 'Assign/Remove RA (A)',
  HUD_UNIT_TRANSFER: 'Unit Transfer (UT) 59A',
  RD_UNIT_TRANSFER: 'Transfer (T)',
  UNIT_TRANSFER: 'Unit Transfer (UT)',
  GROSS_RENT: 'Gross Rent',
  GROSS_RENT_RD: 'Gross Rent (GR)',
  MOVE_IN_PH_PBV: 'New Admission',
  RECERT_PH_PBV: 'Annual Reexamination',
  INTERIM_PH_PBV: 'Interim Reexamination',
  MOVE_OUT_PH_PBV: 'End of Participation',
  UNIT_TRANSFER_PH_PBV: 'Other Change of Unit',
  FAMILY_SELF_SUFFICIENCY: 'Family Self Sufficiency (FSS)',
  FLAT_RENT_ANNUAL_UPDATE: 'Flat Rent Annual Update',
  RECERT_DEFAULT: 'Recertify',
  INTERIM_DEFAULT: 'Interim',
  FSS_ADDENDUM: 'FSS Addendum Only',
};

export const certStatusNameMap = {
  REOPEN: 'REOPEN',
};
export const certificationTypeNameDefinitionMap = {
  [LIHTC_PROGRAM_NAME]: {
    MOVE_IN: certificationTypeNameDefinitions.MOVE_IN,
    RECERT: certificationTypeNameDefinitions.RECERT_DEFAULT,
    RECERT_UT: certificationTypeNameDefinitions.RECERT_DEFAULT,
    INITIAL: certificationTypeNameDefinitions.INITIAL,
    INITIAL_UT: certificationTypeNameDefinitions.INITIAL,
    INTERIM: certificationTypeNameDefinitions.INTERIM_DEFAULT,
    INTERIM_UT: certificationTypeNameDefinitions.INTERIM_DEFAULT,
    CORRECTION: certificationTypeNameDefinitions.CORRECTION,
    TERMINATION: certificationTypeNameDefinitions.TERMINATION,
    MOVE_OUT: certificationTypeNameDefinitions.MOVE_OUT,
    UNIT_TRANSFER: certificationTypeNameDefinitions.UNIT_TRANSFER,
  },
  [HUD_PROGRAM_NAME]: {
    MOVE_IN: certificationTypeNameDefinitions.MOVE_IN,
    RECERT: certificationTypeNameDefinitions.RECERT_DEFAULT,
    RECERT_UT: certificationTypeNameDefinitions.RECERT_DEFAULT,
    INITIAL: certificationTypeNameDefinitions.INITIAL,
    INITIAL_UT: certificationTypeNameDefinitions.INITIAL,
    INTERIM: certificationTypeNameDefinitions.INTERIM_DEFAULT,
    INTERIM_UT: certificationTypeNameDefinitions.INTERIM_DEFAULT,
    CORRECTION: certificationTypeNameDefinitions.CORRECTION,
    TERMINATION: certificationTypeNameDefinitions.TERMINATION,
    MOVE_OUT: certificationTypeNameDefinitions.MOVE_OUT,
    UNIT_TRANSFER: certificationTypeNameDefinitions.HUD_UNIT_TRANSFER,
    GROSS_RENT: certificationTypeNameDefinitions.GROSS_RENT,
  },
  [RD_PROGRAM_NAME]: {
    CO_TENANT_TO_TENANT: certificationTypeNameDefinitions.CO_TENANT_TO_TENANT,
    EVICTION: certificationTypeNameDefinitions.EVICTION,
    INITIAL: certificationTypeNameDefinitions.MOVE_IN_RD,
    INITIAL_UT: certificationTypeNameDefinitions.MOVE_IN_RD,
    MOVE_IN: certificationTypeNameDefinitions.MOVE_IN_RD, // RD uses Initial for Move In
    INITIATE_ABSENCE: certificationTypeNameDefinitions.INITIATE_ABSENCE,
    RECERT: certificationTypeNameDefinitions.RECERT_RD,
    RECERT_UT: certificationTypeNameDefinitions.RECERT_RD,
    TERMINATE_ABSENCE: certificationTypeNameDefinitions.TERMINATE_ABSENCE,
    MODIFY: certificationTypeNameDefinitions.MODIFY,
    VACATE: certificationTypeNameDefinitions.VACATE,
    ASSIGN_REMOVE_RA: certificationTypeNameDefinitions.ASSIGN_REMOVE_RA,
    UNIT_TRANSFER: certificationTypeNameDefinitions.RD_UNIT_TRANSFER,
    GROSS_RENT: certificationTypeNameDefinitions.GROSS_RENT_RD,
  },
  [PH_PROGRAM_NAME]: {
    MOVE_IN: certificationTypeNameDefinitions.MOVE_IN_PH_PBV,
    RECERT: certificationTypeNameDefinitions.RECERT_PH_PBV,
    INTERIM: certificationTypeNameDefinitions.INTERIM_PH_PBV,
    MOVE_OUT: certificationTypeNameDefinitions.MOVE_OUT_PH_PBV,
    UNIT_TRANSFER: certificationTypeNameDefinitions.UNIT_TRANSFER_PH_PBV,
    // Converted combo transfer certs reuse the base PH label; getCertificationTypeDisplayValue
    // appends " + UT". PH converts to RECERT_UT / INTERIM_UT (no INITIAL_UT). (ENG-30153)
    RECERT_UT: certificationTypeNameDefinitions.RECERT_PH_PBV,
    INTERIM_UT: certificationTypeNameDefinitions.INTERIM_PH_PBV,
    // PH/PBV specific: To be implemented
    // FAMILY_SELF_SUFFICIENCY:
    //   certificationTypeNameDefinitions.FAMILY_SELF_SUFFICIENCY,
    FLAT_RENT_ANNUAL_UPDATE:
      certificationTypeNameDefinitions.FLAT_RENT_ANNUAL_UPDATE,
    FSS_ADDENDUM: certificationTypeNameDefinitions.FSS_ADDENDUM,
  },
};

// More generic mapper function to handle different program names
// Basically if there is not exception defined here, it defaults to LIHTC as
// Many of the programs are LIHTC-like in nature
export const determineCertTypeNameDefinitions = (programName) => {
  if (certificationTypeNameDefinitionMap.hasOwnProperty(programName)) {
    return certificationTypeNameDefinitionMap[programName];
  }

  return certificationTypeNameDefinitionMap[LIHTC_PROGRAM_NAME];
};

// Prose forms of the names above, for sentences (confirmation modals and the like) where the
// trailing short codes and form numbers read as noise. Only those codes come off: the rest of the
// wording is kept verbatim, so "Recert" and "Recertify" stay as the business says them. Keyed by
// the definition rather than by certification type so the program-aware resolution above stays the
// single source of truth.
export const certificationTypePlainNames = {
  [certificationTypeNameDefinitions.CO_TENANT_TO_TENANT]: 'Co-Tenant to Tenant',
  [certificationTypeNameDefinitions.CORRECTION]: 'Correction for Recert',
  [certificationTypeNameDefinitions.EVICTION]: 'Eviction',
  [certificationTypeNameDefinitions.INITIAL]: 'Initial',
  [certificationTypeNameDefinitions.INITIATE_ABSENCE]: 'Initiate Absence',
  [certificationTypeNameDefinitions.INTERIM]: 'Interim Recert',
  [certificationTypeNameDefinitions.MODIFY]: 'Modify',
  [certificationTypeNameDefinitions.MOVE_IN]: 'Move-In',
  [certificationTypeNameDefinitions.MOVE_IN_RD]: 'Initial',
  [certificationTypeNameDefinitions.MOVE_OUT]: 'Move-Out',
  [certificationTypeNameDefinitions.RECERT]: 'Annual Recert',
  [certificationTypeNameDefinitions.RECERT_RD]: 'Recertification',
  [certificationTypeNameDefinitions.TERMINATION]: 'Termination',
  [certificationTypeNameDefinitions.TERMINATE_ABSENCE]: 'Terminate Absence',
  [certificationTypeNameDefinitions.VACATE]: 'Vacate',
  [certificationTypeNameDefinitions.ASSIGN_REMOVE_RA]: 'Assign/Remove RA',
  [certificationTypeNameDefinitions.HUD_UNIT_TRANSFER]: 'Unit Transfer',
  [certificationTypeNameDefinitions.RD_UNIT_TRANSFER]: 'Transfer',
  [certificationTypeNameDefinitions.UNIT_TRANSFER]: 'Unit Transfer',
  [certificationTypeNameDefinitions.GROSS_RENT]: 'Gross Rent',
  [certificationTypeNameDefinitions.GROSS_RENT_RD]: 'Gross Rent',
  [certificationTypeNameDefinitions.MOVE_IN_PH_PBV]: 'New Admission',
  [certificationTypeNameDefinitions.RECERT_PH_PBV]: 'Annual Reexamination',
  [certificationTypeNameDefinitions.INTERIM_PH_PBV]: 'Interim Reexamination',
  [certificationTypeNameDefinitions.MOVE_OUT_PH_PBV]: 'End of Participation',
  [certificationTypeNameDefinitions.UNIT_TRANSFER_PH_PBV]:
    'Other Change of Unit',
  [certificationTypeNameDefinitions.FAMILY_SELF_SUFFICIENCY]:
    'Family Self Sufficiency',
  [certificationTypeNameDefinitions.FLAT_RENT_ANNUAL_UPDATE]:
    'Flat Rent Annual Update',
  [certificationTypeNameDefinitions.RECERT_DEFAULT]: 'Recertify',
  [certificationTypeNameDefinitions.INTERIM_DEFAULT]: 'Interim',
  [certificationTypeNameDefinitions.FSS_ADDENDUM]: 'FSS Addendum Only',
};

export const getCertificationTypePlainName = (
  programName,
  certificationType,
) => {
  const definition =
    determineCertTypeNameDefinitions(programName)?.[certificationType] ?? null;

  if (!definition) {
    return null;
  }

  return certificationTypePlainNames[definition] ?? definition;
};

export const GR_SIGNATURE_REQUIRED_CODE = '8';
export const TRACS_CERT_TYPES = [
  'INITIAL',
  'MOVE_IN',
  'RECERT',
  'MOVE_OUT',
  'TERMINATION',
  'GROSS_RENT',
  'INTERIM',
  'UNIT_TRANSFER',
  'RECERT_UT',
  'INTERIM_UT',
  'INITIAL_UT',
];

export const TRANSFER_CERTIFICATION_TYPES = [
  UNIT_TRANSFER_CERT_TYPE,
  RECERT_UT_CERT_TYPE,
  INTERIM_UT_CERT_TYPE,
  INITIAL_UT_CERT_TYPE,
];

/**
 * Certifications that carry the prior full certification forward instead of collecting their own
 * income determination. They do not re-verify the household, so no recertification form is
 * required from its members -- that happens on the next full certification.
 *
 * Mirrors PARTIAL_CERTIFICATION_TYPES in fortress-backend
 * (src/utils/affordablePrograms/partialCertBasis.js).
 */
export const PARTIAL_CERTIFICATION_TYPES = [
  GROSS_RENT_CERT_TYPE,
  RD_GROSS_RENT_CERT_TYPE,
  UNIT_TRANSFER_CERT_TYPE,
  ASSIGN_REMOVE_RA_CERT_TYPE,
  CO_TENANT_TO_TENANT_CERT_TYPE,
];

// HUD 50059-A certification types with no operator-entered next
// recertification date. Termination also uses the 50059-A form but keeps
// the field, by product decision. This list is intentionally not
// PARTIAL_CERTIFICATION_TYPES, which groups partial-basis certifications.
export const HUD_CERT_TYPES_WITHOUT_NEXT_RECERT_DATE = [
  GROSS_RENT_CERT_TYPE,
  MOVE_OUT_CERT_TYPE,
  UNIT_TRANSFER_CERT_TYPE,
];

export const RD_LEASE_CERTIFICATION_TYPES = [
  MOVE_IN_CERT_TYPE,
  INITIAL_CERT_TYPE,
  INITIAL_UT_CERT_TYPE,
  RECERT_CERT_TYPE,
  RECERT_UT_CERT_TYPE,
  ASSIGN_REMOVE_RA_CERT_TYPE,
  CO_TENANT_TO_TENANT_CERT_TYPE,
  VACATE_CERT_TYPE,
];

export const PH_PBV_CERTIFICATION_TYPE = [
  MOVE_IN_CERT_TYPE,
  RECERT_CERT_TYPE,
  INTERIM_CERT_TYPE,
  MOVE_OUT_CERT_TYPE,
  UNIT_TRANSFER_CERT_TYPE,
  FAMILY_SELF_SUFFICIENCY_CERT_TYPE,
  FLAT_RENT_ANNUAL_UPDATE_CERT_TYPE,
  FSS_ADDENDUM_CERT_TYPE,
];

export const RD_LEASE_STATES = [
  'AL',
  'GA',
  'KS',
  'KY',
  'LA',
  'MO',
  'ND',
  'NE',
  'NY',
  'SD',
  'TN',
];

export const custodyOptions = {
  no: 'no',
  yes50CountOnly: 'yes50',
  yesLessThan50: 'yesLessThan50',
  yes50Allowance: 'yes50Allowance',
};
